import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import moment from 'moment-timezone';

import { Status } from '../../classess/status/status';
import { BackupReview } from '../../classess/backupReview/backupReview';
import { BackupReviewDetail } from '../../classess/backupReview/backupReviewDetail';

import {
    setDateTimeFormatGlobalString, isUndNullEmp, isValidDate, getLanguageObj,
    getResponse, getRolesType, handleResponseMessageAsync, settings, styles
} from '../../helpers/main';
import { BackupReviewService } from '../../services/backupReviews/BackupReviewService';
import { GlobalFormats } from '../../classess/main/globalFormats';

const { html, icons, images, labels, messages } = settings;

const currentMethod = 'BackupReviewReport';

export default function BackupReviewReport({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        showModal: false,
        reportShowModal: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtBackupReviewDetailsId: '',
        dtBackupReviewDetailsRowId: 0,
        backupReview: BackupReview?.getClass({}, false),
        backupReviewDetail: BackupReviewDetail?.getClass({}, false),
        brdFieldViews: {
            status: {
                label: '',
                badget: '',
            },
            scheduledDate: {
                date: '',
                time: ''
            },
            executionDate: {
                date: '',
                time: ''
            },
            commentary: '',
        },
        status: [Status?.getClass({}, false)],
        userRoles: getRolesType(),
    },
    setModalObj = {},
}) {
    //#region variables
    const [errors, setErrors] = useState({
        scheduledDate: '',
        executionDate: '',
    })
    const [showData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: false,
    });
    const isMount = useRef(false);
    const inpScheduledDateRef = useRef(null);
    const inpExecutionDateRef = useRef(null);

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnReportModalBack',
            },
            report: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnReportModalSave',
            },
            closeModal: {
                defaultClass: 'close border-0 bg-transparent',
                id: 'btnReportModalClose',
            },
        },
        icons: {
            report: {
                id: 'iconReportModalSave',
                defaultClass: icons?.fasFa?.fileInvoice,
            },
            back: {
                id: 'iconReportModalBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            scheduledDate: {
                id: 'inputReportModalScheduledDate',
                defaultClass: 'form-control datetimepicker-input bg-light border-0 shadow-sm text-dark',
                style: { borderRadius: '5px' }
            },
            executionDate: {
                id: 'inputReportModalExecutionDate',
                defaultClass: 'form-control datetimepicker-input bg-light border-0 shadow-sm text-dark',
                style: { borderRadius: '5px' }
            },
        },
        pickers: {
            scheduledDate: {
                id: 'pkReportModalScheduledDate',
            },
            executionDate: {
                id: 'pkReportModalExecutionDate',
            },
        },
        spiners: {
            report: {
                id: 'spReportModalSave',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    //#region backupreviewreport
    const getBackupReviewReport = async ({
        e = undefined,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getBackupReviewReport';
        let response = getResponse({ type: 0 });
        try {
            if (e) e?.preventDefault?.();

            //#region Validation and data preparation
            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            const setDataBackupReviewDetail = response?.result?.backupReviewDetail || {};

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion Validation and data preparation

            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region getBackupReviewReport
            response = await BackupReviewService.getReport({
                auth: modalObj?.auth,
                id: modalObj?.backupReviewDetail?.backupReviewId || 0,
                dateFrom: setDataBackupReviewDetail?.scheduledDate || '',
                dateTo: setDataBackupReviewDetail?.executionDate || '',
                languageCode: modalObj?.languageObj?.code,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion getBackupReviewReport

            if (response?.result) {
                window.open(response.result, '_blank', 'noopener,noreferrer');
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }
    //#endregion backupreviewreport

    //#region others
    const getData = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region set data input timers
            response = setDateInControl({
                _date: new Date().toISOString(),
                _scheduledDate: modalObj?.backupReviewDetail?.scheduledDate,
                _executionDate: modalObj?.backupReviewDetail?.executionDate,
                subMethod: currentMethod,
            });
            //#endregion set data input timers
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    reportShowModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(`${response?.msgText}`);
        }
    }

    const validateFormData = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            const dateTimeFormat = `${modalObj?.languageObj?.format?.date?.f11} ${modalObj?.languageObj?.format?.time?.f1}`;
            const scheduledDateRaw = inpScheduledDateRef?.current?.value;
            const executionDateRaw = inpExecutionDateRef?.current?.value;

            let hasError = false;
            const requiredMsg = `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`;

            if (!scheduledDateRaw || !isValidDate({ data: moment(scheduledDateRaw, dateTimeFormat)._d, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, scheduledDate: requiredMsg }));
                hasError = true;
            }

            if (!executionDateRaw || !isValidDate({ data: moment(executionDateRaw, dateTimeFormat)._d, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, executionDate: requiredMsg }));
                hasError = true;
            }

            if (hasError) response = getResponse({ type: 1 });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors(prev => ({ ...prev, scheduledDate: '', executionDate: '' }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setData = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setData';
        let response = getResponse({ type: 0 });
        try {
            const scheduledDate = modalObj?.$(`#${controls?.pickers?.scheduledDate?.id}`).datetimepicker('date')?._d;
            const executionDate = modalObj?.$(`#${controls?.pickers?.executionDate.id}`).datetimepicker('date')?._d;
            const format = `${modalObj?.languageObj?.format?.date?.f13} ${modalObj?.languageObj?.format?.time?.f2}`;

            const setDataBackupReviewDetail = {
                ...modalObj?.backupReviewDetail,
                scheduledDate: moment(scheduledDate).format(format),
                executionDate: moment(executionDate).format(format),
            };
            setModalObj(prev => ({
                ...prev,
                backupReviewDetail: setDataBackupReviewDetail,
            }));

            response.result = { backupReviewDetail: setDataBackupReviewDetail, };
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDateInControl = ({
        _date = undefined,
        _scheduledDate = undefined,
        _executionDate = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDateInControl';
        let response = getResponse({ type: 0 });
        try {
            const tf = modalObj?.languageObj?.format?.time?.type;
            const dtf = `${modalObj?.languageObj?.format?.date?.f11} ${modalObj?.languageObj?.format?.time?.picker?.hhmm}`;
            const df = modalObj?.languageObj?.format?.date?.f1;

            const scheduledDate = _scheduledDate ?
                setDateTimeFormatGlobalString({ date: _scheduledDate, dateFormat: df, timeFormat: tf, withSeconds: false })?.result :
                setDateTimeFormatGlobalString({ date: _date, dateFormat: df, timeFormat: tf, withSeconds: false })?.result;

            const executionDate = _executionDate ?
                setDateTimeFormatGlobalString({ date: _executionDate, dateFormat: df, timeFormat: tf, withSeconds: false })?.result :
                setDateTimeFormatGlobalString({ date: _date, dateFormat: df, timeFormat: tf, withSeconds: false })?.result;

            modalObj.$.fn.datetimepicker.Constructor.Default = modalObj?.$.extend({}, modalObj?.$.fn.datetimepicker.Constructor.Default, {
                icons: settings?.react?.tempusDominus?.icons,
                buttons: settings?.react?.tempusDominus?.buttons,
                tooltips: settings?.react?.tempusDominus?.tooltips({ languageId: modalObj?.languageObj?.id }),
                locale: modalObj?.languageObj?.id,
            });

            const pickerOptions = (date) => ({
                date,
                default: false,
                timepicker: true,
                format: dtf,
            });

            modalObj?.$(`#${controls?.pickers?.scheduledDate?.id}`).datetimepicker('options', pickerOptions(scheduledDate));
            modalObj?.$(`#${controls?.pickers?.executionDate.id}`).datetimepicker('options', pickerOptions(executionDate));

            return getResponse({ type: 0 });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <Modal backdrop='static' show={modalObj?.reportShowModal} centered>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='backupReviews' src={images?.icons?.backupReviews} style={{ ...styles?.cardHeaderLogo }}></img>
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.backupReviewDetail?.[modalObj?.languageObj?.id]}</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className='badge badge-pill badge-info py-1 px-2 text-uppercase' style={html?.badges?.micro}>
                                {labels?.report?.[modalObj?.languageObj?.id]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    device='button'
                    className='close border-0 bg-transparent'
                    data-dismiss='modal'
                    aria-label='Close'
                    disabled={process?.showLoading}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: '' })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header >
            <form onSubmit={(e) => getBackupReviewReport({ e: e, subMethod: 'form - onSubmit' })}>
                <Modal.Body className='p-0'>
                    <div className='card-body p-4'>
                        {showData ? (
                            <div className='row'>
                                <div className='col-12 mb-3' hidden={modalObj?.userRoles?.isAnonymous}>
                                    <div className='form-group'>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-2' style={html?.labels?.detailMicro}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.scheduledDate?.[modalObj?.languageObj?.id]}
                                        </small>
                                        {!isUndNullEmp({ data: modalObj?.backupReviewDetail?.scheduledDate, subMethod: controls?.inputs?.scheduledDate?.id })?.result && (
                                            <div id={controls?.pickers?.scheduledDate?.id} className='input-group date' data-target-input='nearest'>
                                                <input id={controls?.inputs?.scheduledDate?.id}
                                                    ref={inpScheduledDateRef}
                                                    className='form-control datetimepicker-input bg-light border-0 shadow-sm text-dark'
                                                    style={{ borderRadius: '5px' }}
                                                    disabled={process?.showLoading}
                                                    data-target={`#${controls?.pickers?.scheduledDate?.id}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setErrors(prev => ({ ...prev, scheduledDate: '' }))}
                                                    placeholder={labels?.scheduledDate?.[modalObj?.languageObj?.id]}
                                                    title={labels?.scheduledDate?.[modalObj?.languageObj?.id]}
                                                    type='text'
                                                />
                                                <div className='input-group-append' data-target={`#${controls?.pickers?.scheduledDate?.id}`} data-toggle='datetimepicker'>
                                                    <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                </div>
                                            </div>
                                        )}
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.scheduledDate)}</div>
                                    </div>
                                </div>

                                <div className='col-12 mb-0' hidden={modalObj?.userRoles?.isAnonymous}>
                                    <div className='form-group'>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-2' style={html?.labels?.detailMicro}>
                                            <i className={icons?.faFa?.calendarAlt} /> {labels?.executionDate?.[modalObj?.languageObj?.id]}
                                        </small>
                                        {!isUndNullEmp({ data: modalObj?.backupReviewDetail?.executionDate, subMethod: controls?.inputs?.executionDate?.id })?.result && (
                                            <div id={controls?.pickers?.executionDate?.id} className='input-group date' data-target-input='nearest'>
                                                <input id={controls?.inputs?.executionDate?.id}
                                                    ref={inpExecutionDateRef}
                                                    className='form-control datetimepicker-input bg-light border-0 shadow-sm text-dark'
                                                    style={{ borderRadius: '5px' }}
                                                    disabled={process?.showLoading}
                                                    data-target={`#${controls?.pickers?.executionDate?.id}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setErrors(prev => ({ ...prev, executionDate: '' }))}
                                                    placeholder={labels?.executionDate?.[modalObj?.languageObj?.id]}
                                                    title={labels?.executionDate?.[modalObj?.languageObj?.id]}
                                                    type='text'
                                                />
                                                <div className='input-group-append' data-target={`#${controls?.pickers?.executionDate?.id}`} data-toggle='datetimepicker'>
                                                    <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                </div>
                                            </div>
                                        )}
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.executionDate)}</div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div></div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button id={controls?.buttons?.report?.id}
                            className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4'
                            style={{ borderRadius: '5px' }}
                            disabled={process?.showLoading}
                            hidden={modalObj?.type === 2}
                            title={labels?.report?.[modalObj?.languageObj?.id]}
                            type='submit'>
                            {process?.showLoading ? (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            ) : (
                                <i id={controls?.icons?.report?.id} className={`${icons?.fasFa?.fileInvoice}`} />
                            )} {labels?.report?.[modalObj?.languageObj?.id]}
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className='btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4'
                            style={{ borderRadius: '5px' }}
                            disabled={process?.showLoading}
                            title={labels?.close?.[modalObj?.languageObj?.id]}
                            type='button'
                            onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                            <i id={controls?.icons?.back?.id} className={`${icons?.fasFa?.arrowCircleLeft}`}></i> {labels?.back?.[modalObj?.languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal >
    )
}